import useCustomerUsers from "../data/CustomerUser/useCustomerUsers";

export function useUserLookup(customerId: string) {
  const { customerUsers } = useCustomerUsers(customerId);

  const lookupUser = (userId: string) => {
    if (!customerUsers.isLoading && customerUsers.data) {
      return customerUsers.data.find((user) => user.id === userId);
    } else {
      return undefined;
    }
  };

  return {
    isLoading: customerUsers.isLoading,
    lookupUser,
  };
}
